import React, { ChangeEvent } from 'react';

export function checkWordCount(event: ChangeEvent) {
  const elem = event.target as HTMLInputElement;
  const target = document.getElementById(`word_${elem.name}`);
  if (target) target.innerHTML = String(elem.value ? elem.value.length : 0);
}

export const WordCount = ({ target, maxCount }: { target: string; maxCount: number }) => {
  return (
    <div
      style={{
        float: 'right',
        color: '#747474',
        fontSize: '12px',
        display: 'block',
      }}
    >
      <span id={`word_${target}`}>0</span>/{maxCount}
    </div>
  );
};
